import { InjectionToken } from "@angular/core";

export interface VersionDataEndpoints {
    getVersionDetails: string;
}

export const VERSION_DATA_ENDPOINTS = new InjectionToken<VersionDataEndpoints>("Version data endpoints");
